module.exports = __webpack_public_path__ + "img/collectiongallery_hearts@2x.a85ab5f.webp";